// Phase 3.2a — Cycle Count list screen, migrated to shadcn/Tailwind.
//
// UI only: the MUI/antd Table, the ApparelSubmenu toolbar, the antd Drawer create
// form and the antd Modal/SpinLoader spinners are replaced by the shared DataTable
// (via CycleCountTable), a PageHeader + built-in search/pagination, a Dialog
// (CreateCycleCountDialog) and LoadingOverlay. Every dispatch / useSelector /
// navigate / payload is unchanged — all handlers below are the legacy ones.
import { useEffect, useState } from "react"
import ApparelMenu from "./SubComponents/apparelMenu"
import { deepCopyFunction } from "../Utils/helpers"
import AppConstant from "../Globals/AppConstants"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { createOrUpdateCycleCountAction, getCycleCountListAction, getCycleCountReportAction } from "../Store/actions/apparelAction"
import { LoadingOverlay } from "../shared/loading-overlay"
import { Button } from "ui/button"
import CycleCountTable from "./inventory/CycleCountTable"
import CreateCycleCountDialog from "./inventory/CreateCycleCountDialog"


const CycleCount = () => {
    const searchtemp: any = {
        searchText: "",
        offset: 0,
        limit: 10,
        page: 1
    };
    const [filterData, setFilterData] = useState<any>(deepCopyFunction(searchtemp));

    const cycleCountTemp = {
        cycleCountId: "",
        name: "",
        statusRefId: null
    }
    const dispatch = useDispatch()
    const apparelReducerState: any = useSelector((state: any) => state.ApparelReducerState);
    const { getCycleCountListData, createOrUpdateCycleCountLoad, getCycleCountListLoad, getCycleCountReportOnLoad, getCycleCountReportData } = apparelReducerState;

    const cycleCountList = getCycleCountListData?.getCycleCountList?.cycleCountList;
    const [disablesaveButon, setDisablesaveButon] = useState(false)
    const [page] = useState(1);
    const [open, setOpen] = useState(false);
    const [addButtondisable, setAddButtondisable] = useState(false);
    const cycleCountPage = getCycleCountListData?.getCycleCountList?.page;
    const [cycleCountReportLoad, setCycleCountReportLoad] = useState(false)
    const [refreshLoad, setRefreshLoad] = useState<any>(false)
    const [addCycleValue, setAddCycleValue] = useState<any>(deepCopyFunction(cycleCountTemp));
    const navigate = useNavigate()

    useEffect(() => {
        if (refreshLoad && !createOrUpdateCycleCountLoad) {
            getCycleCount();
            setRefreshLoad(false);
            setDisablesaveButon(false);
            clearCycleValidationAndClose()
        }
    }, [refreshLoad, createOrUpdateCycleCountLoad]);

    const getsearchTextdataList = (searchText: any) => {
        setFilterData({ ...filterData, searchText: searchText, offset: 0, page: 1 })
    }

    useEffect(() => {
        if (cycleCountList) {
            cycleCountList[0].isCompleted == 1 ? setAddButtondisable(true) : setAddButtondisable(false)
        }
    }, [cycleCountList])

    const getCycleCount = () => {
        let payload = {
            searchText: filterData?.searchText,
            limit: 10,
            offset: filterData?.offset
        }
        dispatch(getCycleCountListAction(payload))
    }
    useEffect(() => {
        if (filterData.searchText.length >= 0) {
            getCycleCount()
        }
    }, [filterData])

    const handlePagination = (page: any, offset: any) => {
        setFilterData({ ...filterData, page: page, offset: offset })
    }

    // DataTable gives a 1-based page; translate to the legacy offset math.
    const onPageChange = (nextPage: number) => {
        let offset = ((nextPage * 10) - 10 === 0) ? 0 : (nextPage * 10) - 10;
        handlePagination(page, offset);
    }

    const clearCycleValidationAndClose = () => {
        setAddCycleValue(deepCopyFunction(cycleCountTemp))
        setOpen(false);
    }

    const redirectHandler = (record: any) => {
        if (record?.statusRefId == 1) {
            createOrUpdateApi(record)
        }
        navigate('/cycle/singleandmultiple', { state: { data: record } })
    }

    const createOrUpdateApi = (data: any) => {
        setDisablesaveButon(true);
        let payload = {
            cycleCountJobId: data?.cycleCountJobId ? data?.cycleCountJobId : "",
            name: addCycleValue?.name ? addCycleValue?.name : data?.name,
            statusRefId: data?.statusRefId ? 2 : 1,
        }
        dispatch(createOrUpdateCycleCountAction(payload))
        setRefreshLoad(true)
        setOpen(false)
    };

    // Api To download excel file format cyclecount data
    const saveAsXlsxFile = () => {
        let sheetName = "Mukizh Cycle Count Report"
        var pre: any =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
        var inp: any = getCycleCountReportData?.getcycleCountReportList;
        var link = document.createElement("a");
        link.href = pre + inp;
        link.download = sheetName + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const cycleCountReportData = (data: any) => {
        let payload = {
            cycleCountJobId: data?.cycleCountJobId
        };
        dispatch(getCycleCountReportAction(payload))
        setCycleCountReportLoad(true);
    }

    useEffect(() => {
        if (cycleCountReportLoad && !getCycleCountReportOnLoad) {
            setTimeout(() => {
                setCycleCountReportLoad(false)
                saveAsXlsxFile()
            }, 2000);
        }
    }, [cycleCountReportLoad, getCycleCountReportOnLoad]);

    return (
        <div className="mz h-full overflow-y-auto px-6 py-4">
            <ApparelMenu selectedKey="5" />
            <CycleCountTable
                data={cycleCountList}
                loading={getCycleCountListLoad}
                onRowClick={redirectHandler}
                onDownload={cycleCountReportData}
                reportLoading={cycleCountReportLoad}
                searchValue={filterData?.searchText}
                onSearch={getsearchTextdataList}
                searchPlaceholder={"Search By Name/Cycle Count ID"}
                title="Cycle Count"
                headerActions={
                    <Button disabled={addButtondisable} onClick={() => setOpen(true)}>
                        {AppConstant?.add}
                    </Button>
                }
                pagination={{
                    page: cycleCountPage?.currentPage || 1,
                    total: cycleCountPage?.totalCount || 0,
                    onChange: onPageChange,
                }}
            />
            <CreateCycleCountDialog
                open={open}
                name={addCycleValue?.name}
                onNameChange={(value) => setAddCycleValue({ ...addCycleValue, name: value })}
                onSubmit={() => createOrUpdateApi({})}
                onCancel={clearCycleValidationAndClose}
                saving={disablesaveButon}
            />
            <LoadingOverlay loading={createOrUpdateCycleCountLoad} />
            <LoadingOverlay loading={cycleCountReportLoad} label="Downloading report…" />
        </div>
    )
}



export default CycleCount
